import 'number.isinteger'
